
import {catchError, map} from 'rxjs/operators';
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi } from '@smdapp/ng-shared/components/loading-overlay/loading-interceptor';
import { AppBackEndService } from "@smdapp/shared/services/app-back-end.service";
import { Assinatura } from "@smdapp/shared";


declare var location: Location;
declare var sdkDesktop:any;

@Injectable()
export class VisualizadorService extends AppBackEndService<Assinatura>
{
    getNewEntity()
    {
      return Assinatura.criarVazio();
    }

    protected getResourceURL(): string
    {
      return 'tramite/[idDocumento]/assinatura';
    }

    idAssinante: string;

    private getOptions()
    {
        return {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin' : '*',
                'Content-Type': 'application/json'
            })
        };         
    }

    consultarTramiteExterno(chaveTramite: string, idAssinante: number)
    {
        let url = `${location.origin}/smd_spa/rest/api/externo/tramite/${chaveTramite}/${idAssinante}`;          
        return this.http.get(url, blockUi({options:this.getOptions()}));
    }

    downloadArquivoAssinado(chaveTramite: string, idAssinante: number, idDocumento:number): any
    {      
        let url = `${location.origin}/smd_spa/rest/api/externo/tramite/${chaveTramite}/${idAssinante}/${idDocumento}/arquivo-assinado/conteudo`;
        return this.http.get(url,  blockUi({options:this.getOptions(), responseType: 'blob' }));
    }    

    downloadArquivoOriginalSemMarcaDagua(chaveTramite: string, idAssinante: number,idDocumento:number): any
    {
        let url = `${location.origin}/smd_spa/rest/api/externo/tramite/${chaveTramite}/${idAssinante}/${idDocumento}/arquivo-original/conteudo`;
        return this.http.get(url,  blockUi({options:this.getOptions(), responseType: 'blob' }));
    }

    rejeitarDocumentoTramiteAction(chaveTramite: string, idAssinante: number,justificativa: string)
    {
        let options = {
            headers: new HttpHeaders({'Content-Type': 'application/json',})
        }

        let corpo = {
            'justificativa': justificativa
        }

        let url = `${location.origin}/smd_spa/rest/api/externo/tramite/${chaveTramite}/${idAssinante}/rejeitar-assinatura`;
        return this.http.post(url, corpo, blockUi({options}));
    }

    registrarAssinaturaDigitalOnline(chaveTramite: string, idAssinante : number, idTramite: number, callback: Function, callbackError: Function): any 
    {      
      let options = {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
        observe: "response"
      };

      let fase0 = `${location.origin}/smd_spa/rest/api/externo/tramite/${chaveTramite}/${idAssinante}/${idTramite}/registrar-assinatura/digital-online-fase0`;
      this.http.post(fase0, null, blockUi(options))
      .subscribe((response: HttpResponse<any>) => {

        let serverUrl = getServerUrl();
        let headerToken = response.headers.get('x-smd-token-plg-digit');    
        
        let fase1 = `${serverUrl}rest/api/externo/tramite/${chaveTramite}/${idAssinante}/${idTramite}/registrar-assinatura/digital-online-fase1`;
        var fileParameters = [{
          "Arquivo" : 'nome-do-pdf.pdf',
          "url" : fase1,
          "checked" : true
        }];
  
        let fase2 = `${serverUrl}rest/api/externo/tramite/${chaveTramite}/${idAssinante}/${idTramite}/registrar-assinatura/digital-online-fase2`;        
        var parameters =  {
          "serverURL" : fase2,
          "nextURL" : `tramite/${idTramite}`,
          "encodedFileParam" : "ENCDATA",
          "encodedFileCount" : "QTYDATA",
          "cookie": "x-smd-token-plg-digit=" + headerToken,
          "encodedFileId" : "IDDATA",
          "colCount" : "1",
          "colName.0" : "Arquivo",
          "colAlias.0" : "$arquivo",
          "generateLog" : "true",
          "digestAlgorithm" : "SHA-256",
          "sendPartialDocuments" : "true"
        };

        let callbackErrorCheckStarted = function(error){
          callbackError("Para realizar assinatura digital é necessário que o aplicativo EVO SDK Desktop esteja instalado na sua máquina e em execução. Por favor, inicialize e tente novamente", error);
        }
  
        let callbackErrorSignHashOnly = function(error){
          let msg = "";
          if(JSON.parse(error)){
            let errObj = JSON.parse(error);
            let causes = errObj.failure.causes;
  
            if(causes.length > 1){
              msg = causes[1].localizedMessage;
            } else {
              msg = causes[0].localizedMessage;
            }
  
          }
  
          callbackError("Erro na chamada do aplicativo responsável por realizar a assinatura digital EVO SDK Desktop. " + msg);          
        }
  
        let callbackCheckStarted = function(resultStr){
          try {
            let result = JSON.parse(resultStr);
            if(result.alive){
              let major:number = result.version.split('.')[0];
              let minor:number = result.version.split('.')[1];
              let patch:number = result.version.split('.')[2];
  
              if( (major < 1) ||
                (major == 1 && minor == 0 && patch < 17) ){
                  callbackError("O aplicativo responsável por realizar assinatura digital EVO SDK Desktop que está sendo executado está em uma versão antiga. Por favor, atualize para versão igual ou superior a 1.0.17", new Error("O EVO SDK Desktop que está sendo executado está em uma versão antiga. Por favor, atualize para versão igual ou superior a 1.0.17"));
                } else {
                  sdkDesktop.setParameters(parameters);
                  sdkDesktop.setFileParameters(fileParameters);
                  sdkDesktop.signHashOnly(callback, callbackErrorSignHashOnly);
                }
            } else {
              callbackError("Para realizar assinatura digital é necessário que o aplicativo EVO SDK Desktop esteja instalado na sua máquina e em execução. Por favor, inicialize e tente novamente.", new Error("Para realizar assinatura digital é necessário que o aplicativo EVO SDK Desktop esteja instalado na sua máquina e em execução. Por favor, inicialize e tente novamente."));
            }
          } catch(err){
            callbackError("Erro ao realizar assinatura digital online", err);
          }
        };
  
        sdkDesktop.checkStarted(callbackCheckStarted, callbackErrorCheckStarted);
      }, e => {
        let msg: string = "Não foi possível registrar assinatura ";
        //mensagem tratada no back-end
        let erro: string = e.error.mensagem;
       
        erro?msg += erro:msg;
        callbackError(msg);
      })
    }

    registrarAssinaturaDigitalOnlineFase3(chaveTramite: string, idTramite: number, idAssinante: number): any {

        let options = {
          headers: new HttpHeaders({'Content-Type': 'application/json',})
        };
        let corpo = {
        }
    
        let serverUrl = getServerUrl();
        let fase3 = `${serverUrl}rest/api/externo/tramite/${chaveTramite}/${idTramite}/${idAssinante}/registrar-assinatura/digital-online-fase3`;
        return this.http.post(fase3, corpo, blockUi(options)).pipe(
              map(response => this.convertToType(response)),
              catchError((e) => this.handleError(e)),);
      }

      obterParametrosGovBr(chaveTramite: string, idTramite: number, idAssinante: number)
      {
        let options = {
          headers: new HttpHeaders({'Accept': 'application/json'})
        };

        return this.http.get(`${getServerUrl()}rest/api/externo/tramite/${chaveTramite}/${idTramite}/${idAssinante}/redirecionar/govbr`, blockUi(options)).pipe(
        catchError((e) => this.handleError(e)));
      }

      registrarAssinaturaGovBr(chaveTramite: string, idTramite: number, idAssinante: number, code: string, assinatura: Assinatura)
      {
        let options = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
        };

        return this.getHttpClient().post(
          `${getServerUrl()}rest/api/externo/tramite/${chaveTramite}/${idTramite}/${idAssinante}/${code}/registrar-assinatura/govbr`,
          assinatura,
          blockUi(options)).pipe(
          catchError((e) => this.handleError(e)));
      }

}

function getServerUrl() {
  let serverUrl;

  if (window["ur_firepass_host"] && window["ur_baseurl"]) {
    if (window["F5_Domain"] != null && window["F5_Domain"].indexOf("web.bndes.net") >= 0) {
      serverUrl = "https://web.bndes.gov.br/smd_spa/";
    } else if (window["F5_Domain"] != null && window["F5_Domain"].indexOf("web.hom.bndes.net") >= 0) {      
      serverUrl = "https://web-h.bndes.gov.br/smd_spa/";
    } else {
      serverUrl = window.location.origin + window.location.pathname;
    }
  }
  else {
    serverUrl = window.location.origin + "/smd_spa/";
  }
  return serverUrl;
}
